import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *密保问题列表
 * 
*/

export const sQuestionList = () => Http.get(`${baseUrl}/password/question/all` )

/**
 *保存密保问题
 * @param params
 * 
*/

export const saveQuestion = params => Http.post(`${baseUrl}/password/question`, params )

/**
 *我的密保问题
 * 
*/

export const myQuestion = () => Http.get(`${baseUrl}/password/question` )

/**
 *验证密保问题
 * @param params
 * 
*/

export const verQuestion = params => Http.put(`${baseUrl}/password/question/valid`, params )

/**
 *更新密保问题
 * @param params
 * 
*/

export const editQuestion = params => Http.put(`${baseUrl}/password/question`, params )

/**
 *根据username获取密保问题
 * @param params
 * 
*/

export const userQuestion = params => Http.get(`${baseUrl}/password/question/username`, { params } )

/**
 *根据username验证密保问题
 * @param params
 * 
*/

export const userVerQuestion = params => Http.put(`${baseUrl}/password/question/username/valid`, params )

/**
 *根据username重置密码
 * @param params
 * 
*/

export const resetPass = params => Http.put(`${baseUrl}/password/question/username/password`, params )
